import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getUserActivities = async (id, post_id) => {
  const { data, error } = await supabase
    .from('user_activities')
    .select('*')
    .eq('user_id', id)
    .eq('post_id', post_id)

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useUserActivities(id: string, post_id: string) {
  return useQuery({
    queryKey: ['useUserActivities', id, post_id],
    queryFn: () => getUserActivities(id, post_id),
    enabled: Boolean(id),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
  })
}
